/**
 * The three settings routes, aggregated.
 *
 * The feature backs more than one route, so the file name is plural
 * (`.routes.tsx`) and the importer knows to expect an array — a `.route.tsx`
 * importer expects a single object, and consistent naming is what removes a
 * whole class of subtle router bugs.
 *
 * Order matters only for reading: `/settings/security` and
 * `/settings/notifications` are distinct paths rather than children of
 * `/settings`, so no `end`-matching subtlety decides which one paints.
 */
import type { RouteObject } from 'react-router-dom';

import { accountSettingsRoute } from './account/account.route';
import { notificationSettingsRoute } from './notifications/notifications.route';
import { securitySettingsRoute } from './security/security.route';

export const settingsRoutes: RouteObject[] = [
  accountSettingsRoute,
  securitySettingsRoute,
  notificationSettingsRoute,
];
